<page-header (onGoBack)="onGoBack()"
             [title]="'profilUser.prefAnalytique.title' | translate">
</page-header>

<please-wait class="content" *ngIf="!liste"></please-wait>

<list-view *ngIf="liste" [liste]="liste"></list-view>
